import { TEXT_DELETE, TEXT_EDIT } from "../../utils/useConstants";
import {
  STYLE_BORDER_BLUE_BUTTON,
  STYLE_BUTTON_BLUE,
  STYLE_BUTTON_BLUE_DISABLED,
  STYLE_BUTTON_BLUE_MODAL,
  STYLE_BUTTON_BLUE_ORDER,
  STYLE_BUTTON_CANCEL_MODAL,
  STYLE_PARENT_TWOBUTTON,
  STYLE_SEMIBOLD_BLUE,
  STYLE_SEMIBOLD_RED,
} from "../../utils/useStyle";

export const BlueButton = ({
  title,
  onClick,
  icon,
  className = `${STYLE_BUTTON_BLUE("EN")} `,
  onSubmit,
}) => {
  return (
    <button
      onSubmit={onSubmit}
      onClick={onClick}
      className={`${className} flex justify-center gap-2 items-center cursor-pointer`}
    >
      {icon ? <img src={icon} className="" /> : ``}
      {title}
    </button>
  );
};

export const DisableButton = ({
  title,
  onClick,
  icon,
  className = `${STYLE_BUTTON_BLUE_DISABLED("EN")}`,
}) => {
  return (
    <button
      onClick={onClick}
      className={`${className} flex justify-center gap-2 items-center`}
    >
      {icon ? <img src={icon} className="" /> : ``}
      {title}
    </button>
  );
};

export const TwoButton = ({
  titlefirst,
  titlesecond,
  onClickFirst,
  onClickSecond,
  className = `${STYLE_PARENT_TWOBUTTON}`,
  classNameCancel = `${STYLE_BUTTON_CANCEL_MODAL}`,
  classNameAccept = `${STYLE_BUTTON_BLUE_MODAL}`,
}) => {
  return (
    <div className={className}>
      <button onClick={onClickFirst} className={classNameCancel}>
        {titlefirst}
      </button>
      <button onClick={onClickSecond} className={classNameAccept}>
        {titlesecond}
      </button>
    </div>
  );
};
